import axiosInstance from '../plugin/axios';

// 개별 데이터 타입 정의
interface DriverScheduleDto {
  work: string; // 작업 형태
  target: string; // 도착 시
  amount: number; // 금액
  name: string; // 기업명
}

interface DriverOrderDto {
  name: string; // 기업명
  orderCount: number; // 발주 건수
}

interface CommonNoticeDto {
  title: string; // 공지 제목
  createdAt: string; // 공지 날짜
}

// 상위 데이터 타입 정의
interface DriverHomeDto {
  schedules: DriverScheduleDto[]; // 작업 스케줄 리스트
  orderCounts: DriverOrderDto[]; // 발주 건수 리스트
  notices: CommonNoticeDto[]; // 공지 리스트
  monthlyAmount: number; // 이번 달 매출 합계
}

// CompanyScheduleDto 인터페이스 정의
interface CompanyScheduleDto {
  work: string; // 작업 형태
  target: string; // 도착시
  amount: number; // 금액
  wanted: string; // 수배 차량
}

// CommonNoticeDto 인터페이스 정의
interface CommonNoticeDto {
  title: string; // 공지 제목
  createdAt: string; // 공지 날짜
}

// CompanyHomeDto 인터페이스 정의
interface CompanyHomeDto {
  schedules: CompanyScheduleDto[]; // 작업 스케줄 리스트
  notices: CommonNoticeDto[]; // 공지 리스트
}

export const fetchDriverHomeData = async (): Promise<DriverHomeDto> => {
  try {
    const response = await axiosInstance.get<DriverHomeDto>('/api/home/driver');
    return response.data;
  } catch (error) {
    throw new Error('데어터를 불러 오는데 실패했습니다.');
  }
};

export const fetchCompanyHomeData = async () => {
  try {
    const response = await axiosInstance.get<CompanyHomeDto>(
      '/api/home/company',
    );
    return response.data;
  } catch (error) {
    throw new Error('데어터를 불러 오는데 실패했습니다.');
  }
};
